import { useEffect, useState } from 'react';
import { formatTime } from './timeHelper';
import { FormatTimeObject } from './types';

export const useTime = () => {
	const [time, setTime] = useState(new Date());
	const [formattedTime, setFormattedTime] = useState<
		FormatTimeObject | undefined
	>();

	useEffect(() => {
		const interval = setInterval(() => {
			const day = new Date();
			setTime(day);
			const formattedTime = formatTime({ day, byUtc: false });

			if (formattedTime) {
				setFormattedTime(formattedTime);
			}
		}, 1000);

		return () => {
			clearInterval(interval);
		};
	}, []);

	return { time, formattedTime };
};
